export const getPublicWizardUrl = (wizardId: string) => {
  const baseUrl = process.env.REACT_APP_PORTAL_URL;
  return `${baseUrl}wizard/${wizardId}`;
};

export const getImageUrl = (pathOrData: string) => {
  // If it's a base64 string, return it directly
  if (pathOrData.startsWith("data:image")) {
    return pathOrData;
  }
  // Otherwise, prepend the CDN URL
  const cdnUrl = process.env.REACT_APP_CDN_URL || "";
  return `${cdnUrl}${pathOrData}.jpg`;
};
